import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { CookieNgrxModule } from '@teamfoster/sdk/cookie-ngrx';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { ButtonModule } from '@teamfoster/sdk/button';



import { DynamicHooksModule } from 'ngx-dynamic-hooks';

@Component({
    selector: 'app-content-block-wysiwyg',
    templateUrl: './content-block-wysiwyg.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './content-block-wysiwyg.component.scss',
    imports: [
        ResizeHtmlImagesPipe,
        CookieNgrxModule,
        TextUtilityModule,
        ButtonModule,
        DynamicHooksModule,
    ]
})
export class ContentBlockWysiwygComponent extends ContentBlockBaseComponent {}
